import { render, staticRenderFns } from "./wodeshequn copy.vue?vue&type=template&id=54165091&scoped=true"
import script from "./wodeshequn copy.vue?vue&type=script&lang=js"
export * from "./wodeshequn copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54165091",
  null
  
)

export default component.exports